/* @flow */
import React from 'react';

import Table from 'components/UIKit/Table';
import DynamicEntityColumns from './DynamicEntityColumns';
import DynamicEntityRows from './DynamicEntityRows';

export default function DynamicEntityTable({
  children, router, sort, order, IconComponent
}: any): React.Element {
  return (
    <Table>
      <DynamicEntityColumns sort={sort} order={order} />
      <DynamicEntityRows router={router} IconComponent={IconComponent}>
        {children}
      </DynamicEntityRows>
    </Table>
  );
}
